import { IAuthRepository, AuthLoginResponse } from '@gishub/domain';
import { AxiosClient } from '../http/axios-client';

export class AuthRepository implements IAuthRepository {
  private readonly http;

  constructor(externalApiUrl: string) {
    // Instancia propia (API externa distinta a configuration.apiUrl) pero con
    // la misma política transversal: token, logging, retry y errores normalizados.
    this.http = AxiosClient.createInstance(externalApiUrl);
  }

  setAccessToken(token: string): void {
    this.http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  clearAccessToken(): void {
    delete this.http.defaults.headers.common['Authorization'];
  }

  async externalLogin(username: string, password: string, alias: string, recaptchaToken?: string): Promise<AuthLoginResponse> {
    const response = await this.http.post<AuthLoginResponse>('/auth/external-login', {
      username,
      password,
      alias,
      recaptchaToken,
    });
    const body = response.data as any;
    // Handle API responses wrapped in { data: { ... } }
    if (body && typeof body === 'object' && 'data' in body && body.data && typeof body.data === 'object') {
      return body.data as AuthLoginResponse;
    }
    return body;
  }
}